'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@repo/ui';
import { cn } from '@repo/ui/utils/cn';
interface AcceptToContinueWithoutSimulationConfirmBoxProps {
  isAccepted: boolean;
  setIsAccepted: (value: boolean) => void;
  className?: string;
}
const AcceptToContinueWithoutSimulationConfirmBox = t0 => {
  const $ = _c(11);
  const {
    isAccepted,
    setIsAccepted,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("gap-xs bg-destructive-foreground/18 p-xs flex cursor-pointer items-center rounded-lg text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setIsAccepted) {
    t2 = checked => setIsAccepted(checked === true);
    $[2] = setIsAccepted;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isAccepted || $[5] !== t2) {
    t3 = <Checkbox id="accept-continue-without-simulation-checkbox" checked={isAccepted} onCheckedChange={t2} />;
    $[4] = isAccepted;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-2xs text-destructive-foreground leading-none">I acknowledge the risk and choose to proceed without simulation.</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3) {
    t5 = <label htmlFor="accept-continue-without-simulation-checkbox" className={t1}>{t3}{t4}</label>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default AcceptToContinueWithoutSimulationConfirmBox;